// extracted by mini-css-extract-plugin
export default {"BlockClientButton":"index__BlockClientButton__qo3St","ActivateClientButton":"index__ActivateClientButton__mzbyh"};